<template>
  <div class="form-editor">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
      <el-form-item :label="$t('microSite.common.form.title')" prop="title">
        <el-input v-model="form.title" :placeholder="$t('microSite.common.form.titlePlaceholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.common.form.subtitle')">
        <el-input v-model="form.subTitle" :placeholder="$t('microSite.common.form.subtitlePlaceholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.form.label.submitBtnContent')" prop="submitBtnContent">
        <el-input v-model="form.submitBtnContent" :placeholder="$t('microSite.form.placeholder.submitBtnContent')"></el-input>
      </el-form-item>
      <!-- <el-form-item :label="$t('microSite.form.label.submitUrl')">
        <el-input v-model="form.submitUrl" :placeholder="$t('microSite.form.placeholder.submitUrl')"></el-input>
      </el-form-item> -->
      <el-form-item :label="$t('microSite.form.label.openAfterSubmit')" prop='nextPage'>
        <SwitchButton v-model="form.nextPage.isActive" :options="switchBtnOptions"></SwitchButton>
        <template v-if="form.nextPage.isActive" >
          <image-link :link="form.nextPage"></image-link>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import editorTemplate from '../../editorTemplate'
import ImageLink from '../../../components/link/index.vue'
import SwitchButton from '../../../components/editor/switchButton.vue'

export default {
  components: {
    SwitchButton,
    ImageLink
  },
  mixins: [editorTemplate],
  data () {
    return {
      form: {
        title: null,
        formKey: null,
        subTitle: null,
        submitBtnContent: null,
        submitUrl: null,
        nextPage: {
          isActive: false,
          isInnerPage: true,
          url: null,
          openNewWindow: false
        }
      },
      rules: {
        title: [
          { required: true, message: this.$t('microSite.form.message.titleRequired'), trigger: 'blur' }
        ],
        submitBtnContent: [
          { required: true, message: this.$t('microSite.form.message.buttonContentRequired'), trigger: 'blur' }
        ]
      },
      switchBtnOptions: [
        {
          labelI18nKey: 'microSite.common.form.no',
          value: false
        },
        {
          labelI18nKey: 'microSite.common.form.yes',
          value: true
        }
      ]
    }
  },
  computed: {

  },
  created () {
    const props = this.renderData.data.props
    this.form.title = props.title
    this.form.formKey = props.formKey
    this.form.subTitle = props.subTitle
    this.form.submitBtnContent = props.submitBtnContent
    this.form.submitUrl = props.submitUrl
    this.form.nextPage = {
      ...props.nextPage
    }
  },
  mounted () {
  },
  methods: {
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.title
      props.subTitle = this.form.subTitle
      props.submitBtnContent = this.form.submitBtnContent
      props.submitUrl = this.form.submitUrl
      props.formKey = this.form.formKey || `crm_${this.renderData.id}`
      props.nextPage = { ...this.form.nextPage, url: this.form.nextPage.url && this.form.nextPage.url.trim() }
      this.updateConfigInRoot()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
